export default __webpack_public_path__ + "static/media/money-bag.a7bc1487.webp";